import { SVGProps } from 'react'
const DigitaneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 641.26 628.97"
    {...props}
  >
    <path
      d="M621.5 107.14h-75.02c-6.83 0-12.37-5.54-12.37-12.37V19.76C534.11 8.84 525.28 0 514.35 0H227.78c-10.92 0-19.76 8.83-19.76 19.76v75.02c0 6.83-5.54 12.37-12.37 12.37H126.9c-10.92 0-19.76 8.83-19.76 19.76v75.02c0 6.83-5.54 12.37-12.37 12.37H19.76C8.84 214.3 0 223.13 0 234.06v74.13c0 10.92 8.83 19.76 19.76 19.76h75.02c6.83 0 12.37 5.54 12.37 12.37v75.02c0 10.92 8.83 19.76 19.76 19.76h74.13c10.92 0 19.76-8.83 19.76-19.76v-75.02c0-6.83 5.54-12.37 12.37-12.37h75.02c10.92 0 19.76-8.83 19.76-19.76v-74.13c0-10.92-8.83-19.76-19.76-19.76h-75.02c-6.83 0-12.37-5.54-12.37-12.37v-69.64c0-6.83 5.54-12.37 12.37-12.37h275.81c6.83 0 12.37 5.54 12.37 12.37v115.18c0 144.25-117.34 261.59-261.59 261.59H126.9c-10.92 0-19.76 8.83-19.76 19.76v80.4c0 10.92 8.83 19.76 19.76 19.76h132.93c210.35 0 381.43-171.16 381.43-381.43V126.99c0-10.92-8.83-19.76-19.76-19.76v-.08Z"
      style={{
        fill: '#fff',
      }}
    />
  </svg>
)
export default DigitaneIcon
